import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { OrderHeadGet } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-dynamic-post-calc',
    templateUrl: './order-head-dynamic-post-calc.component.html',
    styleUrls: ['./order-head-dynamic-post-calc.component.css'],
})
export class OrderHeadDynamicPostCalcComponent implements OnChanges {
    @Input()
    public get?: OrderHeadGet;

    public grid?: GridOptions;

    public readGrid() {
        if (!this.get) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_orderhead_dynamicpostcalc_grid').setLoadDataFunction({ method: 3804, parameters: () => ({ argtype: 'order_internal_no', argvalue: this.get?.order_internal_no }) });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['get']) {
            this.readGrid();
        }
    }
}
